/**
 * Color intention that you want to use in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
    return {
        mode: theme?.customization?.navType,
        common: {
            black: theme.colors?.darkPaper
        },
        primary: {
            light: theme.colors?.primaryLight,
            main: theme.colors?.primaryMain,
            dark: theme.colors?.primaryDark,
            200: theme.colors?.primary200,
            800: theme.colors?.primary800
        },
        secondary: {
            light: theme.colors?.secondaryLight,
            main: theme.colors?.secondaryMain,
            dark: theme.colors?.secondaryDark,
            200: theme.colors?.secondary200,
            800: theme.colors?.secondary800
        },
        tertiary: {
            light: theme.colors?.tertiaryLight,
            main: theme.colors?.tertiaryMain,
            dark: theme.colors?.tertiaryDark,
            200: theme.colors?.tertiary200,
            800: theme.colors?.tertiary800
        },
        error: {
            light: theme.colors?.errorLight,
            main: theme.colors?.errorMain,
            dark: theme.colors?.errorDark
        },
        orange: {
            light: theme.colors?.orangeLight,
            main: theme.colors?.orangeMain,
            dark: theme.colors?.orangeDark
        },
        warning: {
            light: theme.colors?.warningLight,
            main: theme.colors?.warningMain,
            dark: theme.colors?.warningDark
        },
        success: {
            light: theme.colors?.successLight,
            200: theme.colors?.success200,
            main: theme.colors?.successMain,
            dark: theme.colors?.successDark
        },
        grey: {
            50: theme.colors?.grey50,
            100: theme.colors?.grey100,
            500: theme.darkTextSecondary,
            600: theme.heading,
            700: theme.darkTextPrimary,
            900: theme.textDark
        },
        dark: {
            light: theme.colors?.darkTextPrimary,
            main: theme.colors?.darkLevel1,
            dark: theme.colors?.darkLevel2,
            800: theme.colors?.darkBackground,
            900: theme.colors?.darkPaper
        },
        text: {
            primary: theme.darkTextPrimary,
            secondary: theme.darkTextSecondary,
            tertiary: theme.darkTextTertiary,
            dark: theme.textDark,
            hint: theme.colors?.grey100
        },
        background: {
            paper: theme.paper,
            default: theme.backgroundDefault
        }
    };
}

export const colorScalePrimary = [
    [0.0, 'rgb(153, 45, 21)'],
    [0.1, 'rgb(187,55,25)'],
    [0.3, 'rgb(230, 68, 31)'],
    [0.4, 'rgb(255, 104, 46)'],
    [0.5, 'rgb(253, 126, 81)'],
    [0.6, 'rgb(255,135,114)'],
    [0.7, 'rgb(237, 140, 142)'],
    [0.8, 'rgb(243, 162, 161)'],
    [0.9, 'rgb(255,216,209)'],
    [1.0, 'rgb(255,253,249)']
]
export const colorScaleSecondary = [
    [0.0, 'rgb(153, 72, 5)'],
    [0.1, 'rgb(128, 60, 5)'],
    [0.2, 'rgb(153, 72, 5)'],
    [0.3, 'rgb(179, 84, 5)'],
    [0.4, 'rgb(204, 96, 5)'],
    [0.5, 'rgb(235, 110, 8)'],
    [0.6, 'rgb(255, 153, 26)'],
    [0.7, 'rgb(255, 179, 77)'],
    [0.8, 'rgb(255, 204, 128)'],
    [0.9, 'rgb(255, 230, 179)'],
    [1.0, 'rgb(255, 255, 255)'],
]

export const colorScaleBoolean = [
    [0.0, 'rgb(255, 255, 255)'],
    [1.0, 'rgb(43, 148, 108)']
]